import {
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  CREATE_CLIENT_CLEAR,
} from '../constants/ActionTypes';

import { prepareClientObject } from './helpers';

const initialState = {
  loading: false,
  done: false,
};

function clientEditor(state = initialState, action) {
  switch (action.type) {
    case CREATE_CLIENT_REQUEST:
      return { ...state, loading: true, done: false };
    case CREATE_CLIENT_SUCCESS: {
      const client = prepareClientObject(action.results);
      return { ...state, done: true, loading: false, client };
    }
    case CREATE_CLIENT_FAILURE:
      return { ...state, loading: false, done: false };
    case CREATE_CLIENT_CLEAR:
      return { ...state, done: false, client: null };
    default:
      return state;
  }
}

export default clientEditor;
